import {
  uxRouteQuestionOnly,
  uxRouteQuestionPushScan,
  uxConsentScreen,
  uxGender,
  uxRouteNone,
} from "../configs";
import { findBrandByDomain } from "../configs/configLoader";
import { MODAL_STEPS } from "../constants/modal";

interface StepParams {
  isMobile: boolean;
  step: { number: number } | null;
  recommendedSize: any;
}

export const handleStep = ({ isMobile, step, recommendedSize }: StepParams) => {
  const urlParams = new URLSearchParams(window.location.search);

  let userId = localStorage.getItem("uid");

  const isLingerie = urlParams.get("lingerie") === "true";
  const isFootwear =
    urlParams.get("category") === "footwear" ||
    urlParams.get("footwear") === "true";

  const mock = urlParams.get("mock") === "true";
  const qrCode = urlParams.get("qr_code") === "true";

  const brandDefined = findBrandByDomain();

  const isTDF = brandDefined?.name === "TDF";
  const isVelour = brandDefined?.name === "Velour Garments";

  const checkedCookies = localStorage.getItem("checkedCookies") === "true";

  const firstStep = isMobile ? MODAL_STEPS.GENDER : MODAL_STEPS.INTRO;

  const footwearFirtStep = uxRouteNone
    ? MODAL_STEPS.BREASTS
    : MODAL_STEPS.DEVICE_SELECT;

  let resolvedStep = isFootwear ? footwearFirtStep : firstStep;

  const hasResult = !!recommendedSize && !!userId;

  if (hasResult) {
    return MODAL_STEPS.RESULT;
  }

  if (isMobile && isTDF) resolvedStep = MODAL_STEPS.INTRO_MOBILE;
  else if (isFootwear) resolvedStep = footwearFirtStep;
  else if (uxConsentScreen && !checkedCookies)
    resolvedStep = MODAL_STEPS.CONSENT;
  else if (isMobile && uxGender) resolvedStep = MODAL_STEPS.INTRO_MOBILE;

  if (isLingerie && step?.number === resolvedStep?.number)
    return MODAL_STEPS.BREASTS;
  if (isMobile && isVelour && firstStep?.number === MODAL_STEPS.GENDER.number)
    return MODAL_STEPS.INTRO_MOBILE;

  if (isFootwear) {
    if (uxRouteQuestionOnly) return MODAL_STEPS.SHOE_GENDER;
    if (uxRouteQuestionPushScan) return MODAL_STEPS.QR_CODE;
  }

  if (isMobile && step?.number === MODAL_STEPS.INTRO.number)
    return MODAL_STEPS.GENDER;
  if (!isMobile && step?.number === MODAL_STEPS.GENDER.number)
    return MODAL_STEPS.INTRO;

  const mockOutOfRange = urlParams.get("outOfRange") === "true";

  if (mock && mockOutOfRange) return MODAL_STEPS.ERROR;
  if (mock && qrCode) return MODAL_STEPS.QR_CODE;

  return resolvedStep;
};
